import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ResourceActions from '@Actions/production/resourceActions';
import { v4 as uuidv4 } from 'uuid';
import {
  Select, notification,
} from 'antd';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const SelectResourceGroup = ({
  onChange, user, resourcesGroup, getResourceGroup, getResourceGroupLoading, createResourceGroup,
  createResourceGroupLoading, hasError, selectedResourceGroup, resourceType, mode, dropdownWidth, noApiCall, disabled,
  height, maxTagCount, containerClassName,
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');

  useEffect(() => {
    if (!resourcesGroup && !getResourceGroupLoading && !noApiCall) {
      getResourceGroup(user?.tenant_info?.org_id);
    }
  }, []);

  return (
    <div className={`${containerClassName} resource-selector__wrapper`}>
      <PRZSelect
        value={resourcesGroup ? selectedResourceGroup : ''}
        filterOption={false}
        onChange={(value) => onChange(value)}
        onInputKeyDown={(e) => {
          if (e.keyCode === 13) {
            // Close the dropdown menu
            e.stopPropagation();
            e.preventDefault();
          }
        }}
        style={{
          border: !(hasError) ? '1px solid rgba(68, 130, 218, 0.2) !important' : '1px solid red !important',
          borderRadius: '2px',
          height: height || '28px',
          width: dropdownWidth,
          fontSize: '13px',
          background: 'white',
        }}
        onSearch={(value) => {
          setSearchKeyword(value);
        }}
        showSearch
        loading={getResourceGroupLoading || createResourceGroupLoading}
        disabled={getResourceGroupLoading || createResourceGroupLoading || disabled}
        maxTagCount={maxTagCount}
        mode={mode}
        allowClear
      >
        {!resourcesGroup?.data?.filter((item) => item?.resource_group_type === resourceType)?.filter((item) => (searchKeyword ? item?.resource_group_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))?.length
            && (
              <Option key="BABLU" value={searchKeyword}>
                <div onClick={() => {
                  if (resourcesGroup?.data?.map((item) => item?.resource_group_name?.toLowerCase())?.includes(searchKeyword?.toLowerCase())) {
                    notification.open({
                      type: 'warning',
                      message: 'This resource group is already created',
                      duration: 4,
                      placement: 'top',
                    });
                  } else if (!resourcesGroup?.data?.map((item) => item?.resource_group_name?.toLowerCase())?.includes(searchKeyword?.toLowerCase())
                        && !getResourceGroupLoading && searchKeyword) {
                    const resourceGroupPayload = {
                      resource_group_type: resourceType,
                      org_id: user?.tenant_info?.org_id,
                      resource_group_name: searchKeyword,
                    };
                    createResourceGroup(resourceGroupPayload, (createdResourceGroup) => {
                      getResourceGroup(user?.tenant_info?.org_id);
                      setSearchKeyword('');
                      if (['EQUIPMENT', 'OTHER'].includes(resourceType)) {
                        onChange(selectedResourceGroup ? [...selectedResourceGroup, createdResourceGroup?.resource_group_id] : [createdResourceGroup?.resource_group_id]);
                      }
                      else {
                        onChange(createdResourceGroup?.resource_group_id);
                      }
                    });
                  }
                }}
                >
                  {(getResourceGroupLoading || createResourceGroupLoading) ? '' : `Add New "${searchKeyword}"`}
                </div>
              </Option>
            )}
        {resourcesGroup && resourcesGroup?.data?.filter((item) => item?.resource_group_type === resourceType)?.filter((item) => (searchKeyword ? item?.resource_group_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))?.map((item) => (
          <Option key={item.resource_group_id} value={item.resource_group_id}>
            {`${item?.resource_group_name }`}
          </Option>
        ))}
      </PRZSelect>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TemplateRouteReducers, ResourceReducers, ProcessReducers,
}) => ({
  user: UserReducers.user,
  resourcesGroup: ResourceReducers.resourcesGroup,
  dropdownResources: ResourceReducers.dropdownResources,
  getProcessesLoading: ProcessReducers.getProcessesLoading,
  processes: ProcessReducers.processes,
  getResourceGroupLoading: ResourceReducers.getResourceGroupLoading,
  createResourceGroupLoading: ResourceReducers.createResourceGroupLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getResourceGroup: (orgId) => dispatch(ResourceActions.getResourceGroup(orgId)),
  createResourceGroup: (payload, callback) => dispatch(ResourceActions.createResourceGroup(payload, callback)),
});

SelectResourceGroup.propTypes = {
  user: PropTypes.any,
  getTemplateRoute: PropTypes.func,
  templateRoutes: PropTypes.any,
  resourcesGroup: PropTypes.any,
  createTemplateRouteLoading: PropTypes.bool,
  updateTemplateRouteLoading: PropTypes.bool,
  // history: PropTypes.func,
  callback: PropTypes.func,
  createTemplateRoute: PropTypes.func,
  selectedTemplateRoute: PropTypes.any,
  updateTemplateRoute: PropTypes.any,
  getProcesses: PropTypes.func,
  processes: PropTypes.any,
  getProcessesLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectResourceGroup));
